import React, { Component } from 'react';

export default class Vouchers extends Component {
    render() {
        return <div>Vouchers!</div>;
    }
}
